export const RouteAlias = {
  home: '/',
  login: '/users/login',
  signUp: '/users/register',
  inactive: '/users/login?status=inactive',
  accountRecovery: '/users/account-recovery',
  changeEmail: '/users/change-email',
  passwordReset: '/users/password-reset',
  accountActivation: '/users/account-activation',
  activationSuccess: '/users/account-activation/success',
  activationFailed: '/users/account-activation/failed',
  suspended: '/users/account-suspended',
  confirmNewEmail: '/users/confirm-new-email',
  confirmEmail: '/users/confirm-email',
  authLanding: '/users/auth-landing',
};
